import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const reportService = { constants, ...slice, sagas };

export default reportService;

